// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paybalance-select {
    background-color: white;
    margin: 10px 0;
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid;
    position: relative;
}

.paybalance-select .select {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    border-radius: 0;
    height: auto;
    width: 100%;
    cursor: pointer;
}

.paybalance-select .placeholder {
    background: transparent;
    color: #35363e;
    cursor: pointer;
}

.paybalance-select label {
    position: absolute;
    top: -12px;
    padding: 0 5px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 1) 50%,
        rgba(239, 241, 254, 0) 50%
    );
    font-size: 14px;
}

.paybalance-select .menu-select {
    position: absolute;
    background: white;
    left: 0;
    top: 45px;
    margin-top: 10px;
    width: 100%;
    box-shadow: 0 3px 3px 2px rgba(0, 0, 0, 0.075);
    border: 2px solid #7a6be8;
    border-radius: 5px;
    z-index: 99998;
}

.paybalance-select .menu-select ul {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    padding: 5px 0;
}

.paybalance-select .menu-select .search-select {
    border-bottom: 1px solid #ccc;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    padding: 0 10px;
    color: #999;
}

.paybalance-select .menu-select input {
    width: 100%;
    border: 0;
    border-radius: 0;
    padding: 0 10px;
    margin: 0;
}
.paybalance-select .menu-select input::placeholder {
    color: #999;
}

.paybalance-select .menu-select ul li {
    padding: 5px 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.paybalance-select .menu-select ul li:hover {
    background: #c9cff6;
}

.paybalance-select .menu-select ul li svg {
    color: #7a6be8;
    margin: 0 5px;
}

.paybalance-select .menu-select ul li:hover svg {
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SalaryBand/SelectSearch/select.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd;;;;KAIC;IACD,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,OAAO;IACP,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,8CAA8C;IAC9C,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;AACA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".paybalance-select {\r\n    background-color: white;\r\n    margin: 10px 0;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    border: 1px solid;\r\n    position: relative;\r\n}\r\n\r\n.paybalance-select .select {\r\n    background: transparent;\r\n    border: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    border-radius: 0;\r\n    height: auto;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n\r\n.paybalance-select .placeholder {\r\n    background: transparent;\r\n    color: #35363e;\r\n    cursor: pointer;\r\n}\r\n\r\n.paybalance-select label {\r\n    position: absolute;\r\n    top: -12px;\r\n    padding: 0 5px;\r\n    background: linear-gradient(\r\n        0deg,\r\n        rgba(255, 255, 255, 1) 50%,\r\n        rgba(239, 241, 254, 0) 50%\r\n    );\r\n    font-size: 14px;\r\n}\r\n\r\n.paybalance-select .menu-select {\r\n    position: absolute;\r\n    background: white;\r\n    left: 0;\r\n    top: 45px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    box-shadow: 0 3px 3px 2px rgba(0, 0, 0, 0.075);\r\n    border: 2px solid #7a6be8;\r\n    border-radius: 5px;\r\n    z-index: 99998;\r\n}\r\n\r\n.paybalance-select .menu-select ul {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 0;\r\n    margin: 0;\r\n    padding: 5px 0;\r\n}\r\n\r\n.paybalance-select .menu-select .search-select {\r\n    border-bottom: 1px solid #ccc;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 10px;\r\n    color: #999;\r\n}\r\n\r\n.paybalance-select .menu-select input {\r\n    width: 100%;\r\n    border: 0;\r\n    border-radius: 0;\r\n    padding: 0 10px;\r\n    margin: 0;\r\n}\r\n.paybalance-select .menu-select input::placeholder {\r\n    color: #999;\r\n}\r\n\r\n.paybalance-select .menu-select ul li {\r\n    padding: 5px 8px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.paybalance-select .menu-select ul li:hover {\r\n    background: #c9cff6;\r\n}\r\n\r\n.paybalance-select .menu-select ul li svg {\r\n    color: #7a6be8;\r\n    margin: 0 5px;\r\n}\r\n\r\n.paybalance-select .menu-select ul li:hover svg {\r\n    color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
